import React, { useState } from "react";
import Card from "components/card";
import SelectOption from "components/select/SelectOption";
import { Activity } from "lucide-react";

const BreakdownCard = ({ employee }) => {
    const [positionFilter, setPositionFilter] = useState(0);

    return (
        <Card className="flex flex-col gap-6 rounded-2xl border-2 border-slate-200 shadow-lg overflow-hidden">
            <div className="grid items-start gap-1.5 px-6 pt-6 pb-6 bg-gradient-to-br from-slate-50 to-cyan-50 border-b">
                <div className="flex items-center justify-between">
                    <div>
                        <h4 className="text-[18px]">
                            Daily Hours Breakdown
                        </h4>
                        <p className="text-[15px] font-normal text-slate-700">
                            Last 7 days productivity analysis
                        </p>
                    </div>
                    <SelectOption
                        placeholder="All Departments"
                        className=" w-[150px] border-2 border-slate-300"
                        options={[
                            { label: "This Week", value: 0 },
                            { label: "This Month", value: 1 },
                            { label: "This Quarter", value: 2 },
                        ]}
                        value={positionFilter}
                        onChange={setPositionFilter}
                    /> 
                </div>
            </div>
            <div className="pb-6 p-6">
                <div className="h-[300px]">

                </div>
                <div className="bg-gray-200 h-px w-full my-6"></div>
                <div className="space-y-2">
                    <h4 className="font-semibold text-[14px] mb-3">
                        Detailed Daily Breakdown
                    </h4>
                    <div className="grid grid-cols-5 gap-2 text-[11px] font-medium text-slate-700 pb-2 border-b">
                        <span>Date</span>
                        <span className="text-center">Total</span>
                        <span className="text-center">Productive</span>
                        <span className="text-center">Meetings</span>
                        <span className="text-center">Breaks</span>
                    </div>
                    {employee?.details?.daily_breakdown?.map((day, index) => (
                        <div 
                            key={index}
                            className="grid grid-cols-5 gap-2 text-[12px] p-2 rounded-lg hover:bg-slate-50 transition-colors"
                        >
                            <span className="font-medium">{day.date}</span>
                            <span className="text-center font-semibold">{day.total}h</span>
                            <span className="text-center text-cyan-600 font-medium">{day.productive}h</span>
                            <span className="text-center text-purple-600 font-medium">{day.meetings}h</span>
                            <span className="text-center text-orange-600 font-medium">{day.breaks}h</span>
                        </div>
                    ))}
                    <div className="mt-6 p-4 rounded-xl bg-gradient-to-br from-blue-50 to-cyan-50 border border-blue-200">
                        <div className="flex items-start gap-3">
                            <Activity className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                            <div className="text-[13px]">
                                <p className="font-semibold text-blue-900 mb-1">
                                    Productivity Insights
                                </p>
                                <p className="text-blue-800 leading-relaxed">
                                    {employee?.details?.message}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    )
};
export default BreakdownCard;